<template>
    <div class="min-h-screen bg-gray-50">
        <!-- Hero Section -->
        <div class="relative h-64 md:h-80 w-full flex items-center justify-center overflow-hidden">
            <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=900&q=80"
                alt="About Us Hero" class="absolute inset-0 w-full h-full object-cover object-center opacity-80" />
            <div class="relative z-10 flex flex-col items-center justify-center w-full h-full">
                <span class="uppercase tracking-widest text-white text-xs md:text-sm mb-2">Get to Know</span>
                <h1 class="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg mb-2 text-center">About OptimaAI Creator</h1>
                <p class="text-white text-base md:text-lg font-medium drop-shadow text-center">Empowering creators to grow faster and work smarter</p>
            </div>
            <div class="absolute inset-0 bg-gradient-to-b from-blue-900/60 to-transparent"></div>
        </div>

        <!-- Main Content -->
        <div class="max-w-4xl mx-auto -mt-16 pb-16 px-4">
            <div class="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative z-20">
                <section class="mb-8">
                    <p class="text-sm text-gray-500 mb-4">Last Updated: November 2025</p>
                </section>
                <div class="divide-y divide-blue-50">
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center"><span class="mr-2">1.</span>
                            Our Mission</h3>
                        <div class="space-y-4">
                        <p class="text-gray-700 leading-relaxed">
                                Optima AI Creator was founded on a powerful realization: the tools available to content creators are fundamentally inadequate. Creators were forced to juggle a fragmented collection of basic apps for chat, scheduling, and analytics, leading to turmoil and lost revenue. We saw the unmet needs and responded by building a platform that is truly in a league of its own.
                            </p>
                            <p class="text-gray-700 leading-relaxed">
                                We are not just another tool; we are <strong> the ONLY true all-in-one</strong> operating system designed to manage and maximize your entire business. Our advanced, world-class AI goes far beyond simple automation, providing deep, strategic insights to show you exactly how to maximize your income and build a sustainable enterprise. Where competitors offer limited facets of your business, Optima AI Creator covers everything, delivering a depth of integration and intelligence that is unmatched.
                            </p>
                            <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mt-4">
                                <p class="text-gray-800 font-semibold">
                                    Creators typically see an increase in their business of <strong>15 – 40%</strong>.
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center"><span class="mr-2">2.</span>
                            AI Support (Patent Pending)</h3>
                        <div class="space-y-4">
                            <p class="text-gray-700 leading-relaxed">
                                A revolutionary platform deserves revolutionary support. That's why we invented and are patenting the most advanced support feature in the world - The Amazing Help Button.
                            </p>
                            <p class="text-gray-700 leading-relaxed">
                                When you need assistance, our dedicated, live Optima AI Creator assistant is instantly connected. Our AI can literally 'see' your screen in real-time, understanding your exact context and providing immediate, visual, and verbal guidance. This ground-breaking context-aware assistance ensures you never get stuck, never waste a moment, and always use the platform to its full, income-maximizing potential.
                            </p>
                        </div>
                    </section>
                </div>
                <section class="mt-4">
                    
                    <div class="bg-blue-50 border-l-4 border-blue-400 p-4">
                        <p class="text-gray-800 font-semibold">Join the future of creator business management. <strong>Join Optima AI Creator and grow.</strong>
                        </p>
                    </div>
                    </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AboutUs'
}
</script>

